// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fv","advertDetailHeaderLocation__value":"c-m_fw"};